import AnimationA from './animationA';
import AnimationB from './animationB';
import AnimationC from './animationC';
import AnimationD from './animationD';
import AnimationE from './animationE';
import AnimationF from './animationF';
import AnimationG from './animationG';
import TextImgA1 from './textImgA1';
import { getDetaileMoreProducts } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import OtherList from '@/components/ProductCommon/OtherList';
import { LineSpace } from '@/components/ProductComponents';

export default function indexDynamic() {
    const { gloproductlist, useRouter } = useGlobal();
    const { locale } = useRouter();
    const otherProductData = getDetaileMoreProducts(
        gloproductlist,
        locale === 'br' ? ['product_ps_delta_delta_pro_plus'] : ['product_ps_delta_delta_pro', 'product_ps_delta_max_smart_extra_battery', 'product_sg_dg100'],
        '',
        '',
        locale === 'br' ? 'https://br.ecoflow.com/collections/portable-power-stations' : '/collections/smart',
    );

    return (
        <>
            <AnimationA />
            <AnimationG />
            <TextImgA1 />
            <AnimationB />
            <AnimationD />
            <AnimationE />
            <AnimationC />
            <AnimationF />
            <LineSpace height={150} background="transparent" />
            <OtherList theme="black" data={otherProductData} />
        </>
    );
}
